import { useEffect } from "react";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import { useApplicationToast } from "../webcontent/ApplicationToastProvider";
import {
  ArrowDownTrayIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import { useDownloadFormPDF } from "../api/ConsentApi";
import { usePermissionValidator } from "../api/UserPermissionValidators";

type PDFDownloadWrapperProps = {
  report_uuid: string;
};

const PDFDownloadWrapper = ({ report_uuid }: PDFDownloadWrapperProps) => {
  const { showLargeToast } = useApplicationToast();
  const { canDownloadPDF } = usePermissionValidator();
  const {
    isLoading: loadingPDF,
    mutate: downloadFormPDF,
    error: pdfError,
  } = useDownloadFormPDF();

  useEffect(() => {
    if (pdfError) {
      showLargeToast?.({
        title: "Error!",
        message:
          "Couldn't download pdf please try again later or contact support.",
        icon: (
          <div className="bg-red-100 text-red-600 rounded-full p-2">
            <ExclamationTriangleIcon className="w-6" />
          </div>
        ),
      });
    }
  }, [pdfError, showLargeToast]);

  function handlePDFDownload(report_uuid: string) {
    downloadFormPDF(report_uuid);
  }

  if (!canDownloadPDF) {
    return <></>;
  }

  return (
    <div>
      {loadingPDF ? (
        <LoadingSpinner />
      ) : (
        <div
          className="flex flex-row items-center gap-2  underline "
          title="Download PDF"
          onClick={() => handlePDFDownload(report_uuid)}
        >
          View Form{" "}
          <ArrowDownTrayIcon
            className="text-gray-400"
            width={22}
          ></ArrowDownTrayIcon>
        </div>
      )}
    </div>
  );
};

export default PDFDownloadWrapper;
